import React, { useRef } from 'react'
import { SponsorTB } from './styles'
import { logEvent } from '../../../Utils'
import { useIntersectionObserver } from '../../../Hooks/intersectionObservers/useElementOnScreen'
import { Banner } from '../../../Api'
import { Img } from '../../Image/Img'
import { ANALYTICS_TAGS } from '../../../Constant'
import { Lk } from '../../Links/Lk'

type PageHeaderProps = {
  img: string
  banner?: Banner
  link?: string | null
}

export const SponsorTopBanner: React.FC<React.PropsWithChildren<PageHeaderProps>> = ({
  img,
  banner,
  link,
}) => {
  const ref = useRef<HTMLDivElement | null>(null)
  const analytics = {
    name: ANALYTICS_TAGS.banner_impression,
    params: {
      img: img,
      bannerType: 'sponsor',
      sponsor: banner?.sponsor ? banner.sponsor : '',
      tags: banner?.tags ? banner.tags : '',
      location: 'top_banner',
      link: link,
    },
  }
  const isIntersecting = useIntersectionObserver(
    ref,
    {
      root: null,
      threshold: 0.1,
      rootMargin: '0%',
    },
    false,
    analytics
  )
  const log = (event: string) => {
    logEvent(event, {
      img: img,
      bannerType: 'sponsor',
      sponsor: banner?.sponsor ? banner.sponsor : '',
      tags: banner?.tags ? banner.tags : '',
      location: 'top_banner',
      link: link,
    })
    return Promise.resolve()
  }
  return (
    <SponsorTB ref={ref}>
      {link ? (
        <Lk
          link={link}
          onBeforeNavigate={() => log(ANALYTICS_TAGS.banner_click)}
          alt={'Sponsor top banner'}
        >
          <Img src={img} alt="Sponsor top banner" />
        </Lk>
      ) : (
        <Img src={img} alt="Sponsor top banner" />
      )}
    </SponsorTB>
  )
}
